require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./javascript-algorithms-and-data-structures-es-6-create-an-export-fallback-with-export-default.json") })
        }
      }, "path---javascript-algorithms-and-data-structures-es-6-create-an-export-fallback-with-export-default");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---javascript-algorithms-and-data-structures-es-6-create-an-export-fallback-with-export-default!./.cache/json/javascript-algorithms-and-data-structures-es-6-create-an-export-fallback-with-export-default.json
// module id = 2371
// module chunks = 231608221292675